import React, { useState, useEffect } from "react";
import GoogleMapReact from "google-map-react";
import Card from "@material-ui/core/Card";
import axios from "axios";
import { useParams, Link } from "react-router-dom";
import { API_URL1 } from "../services/url";
import Button from "react-bootstrap/Button";
import Paper from "@mui/material/Paper";
import TableContainer from "@mui/material/TableContainer";

const ProsMap = (props) => {
  const { sub_job_truck_id } = useParams();
  const [center, setCenter] = useState({ lat: 32.7458, lng: -111.6859 });
  const [zoom, setZoom] = useState(10);
  const [details, setDetails] = useState({
    color: "N/A",
    size: "N/A",
    qty: "N/A",
    true_qty: "N/A",
    truck: "N/A",
    driver: "N/A",
    customer_name: "N/A",
    customer_site_name: "N/A",
    truck_name: "N/A",
    src: { lat: "", lng: "" },
    destination: { lat: "", lng: "" },
    last_location: { lat: "", lng: "" },
    distance: "N/A",
    item_name: "N/A",
    driversign: false
  });

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {

        var newApiResponse = await axios.get(`${API_URL1}trucker/dispatch/dispatched/status?sub_job_truck_id=${sub_job_truck_id}`, {
          headers: {
            "x-access-token": localStorage.getItem("TruckertokenKey"),
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
          },
        });

        var src;
        var destination;

        var truck_details = newApiResponse.data.data;

        if(truck_details?.quarry_geofence?.lat && truck_details?.quarry_geofence?.lng){
          src = truck_details.quarry_geofence;
        } else {
          try {
            src = truck_details.quarry_geofence ? JSON.parse(truck_details.quarry_geofence) : { lat: "0", lng: "0" };
          } catch (error) {
            console.log(error);
            src = { lat: "0", lng: "0" };
          }
        }

        if(truck_details?.customer_geofence?.lat && truck_details?.customer_geofence?.lng){
          destination = truck_details.customer_geofence;
        } else {
          try {
            destination = truck_details.customer_geofence ? JSON.parse(truck_details.customer_geofence) : { lat: "", lng: "" };
          } catch (error) {
            console.log(error);
            destination = { lat: "", lng: "" };
          }
        }


        // If src's or destination's lat or lng is not integer, then convert it to integer
        src.lat = parseFloat(src.lat);
        src.lng = parseFloat(src.lng);
        destination.lat = parseFloat(destination.lat);
        destination.lng = parseFloat(destination.lng);

        console.log(src, destination);

        setDetails((prevDetails) => ({
          ...prevDetails,
          color: truck_details.color_name || "N/A",
          size: truck_details.size || "N/A",
          qty: truck_details.quantity || "N/A",
          true_qty: truck_details.true_quantity || "N/A",
          truck: truck_details.registration_number || "N/A",
          driver: truck_details.driver_name || "N/A",
          customer_name: truck_details.customer_name || "N/A",
          customer_site_name: truck_details.customer_site_name || "N/A",
          truck_name: truck_details.company_name || "N/A",
          src: src,
          destination: destination,
          item_name: truck_details.item_name || "N/A",
          driversign: truck_details.driversign || false
        }));


        // const response = await axios.get(`${API_URL1}trucker/dispatch/dispatched`, {
        //   headers: {
        //     "x-access-token": localStorage.getItem("TruckertokenKey"),
        //     "Content-Type": "application/json",
        //     "Access-Control-Allow-Origin": "*",
        //   },
        // });

        // const data = response.data.data;
        // const truckId = Number(sub_job_truck_id);

        // const truckDetails = data.find((item) => item.sub_job_truck_id === truckId);
        // if (truckDetails) {
        //   const src = truckDetails.quarry_geofence ? JSON.parse(truckDetails.quarry_geofence) : { lat: "", lng: "" };
        //   const destination = truckDetails.customer_geofence ? JSON.parse(truckDetails.customer_geofence) : { lat: "", lng: "" };

        //   setDetails((prevDetails) => ({
        //     ...prevDetails,
        //     color: truckDetails.color_name || "N/A",
        //     size: truckDetails.size || "N/A",
        //     qty: truckDetails.processing_quantity || "N/A",
        //     truck: truckDetails.registration_number || "N/A",
        //     driver: truckDetails.driver_name || "N/A",
        //     customer_name: truckDetails.customer_name || "N/A",
        //     customer_site_name: truckDetails.customer_site_name || "N/A",
        //     truck_name: truckDetails.company_name || "N/A",
        //     src: src,
        //     destination: destination
        //   }));
        // }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        try {
          const loc_response = await axios.get(
            `${API_URL1}appAdmin/map/findDriverLocation/${sub_job_truck_id}`
          );

          if (loc_response.data.success) {
            var last_location;
            if (loc_response.data.order.last_location?.lat && loc_response.data.order.last_location?.lng) {
              last_location = loc_response.data.order.last_location;
            } else {
              try {
                last_location = loc_response.data.order.last_location ? JSON.parse(loc_response.data.order.last_location) : { lat: "", lng: "" };
              } catch (error) {
                console.log(error);
              }
            }

            const distance = loc_response.data.order.distance || "N/A";

            setDetails((prevDetails) => ({
              ...prevDetails,
              last_location: last_location,
              distance: distance,
            }));
          }
        } catch (error) {
          console.error("Error fetching location data:", error);
        }
        setLoading(false);
      }
    };

    fetchData();
  }, [sub_job_truck_id]);

  const handleApiLoaded = (map, maps) => {
    const { src, destination, last_location, driversign } = details;

    const iconMarker = new maps.MarkerImage(
      "https://img.icons8.com/emoji/344/delivery-truck.png",
      null,
      null,
      null,
      new maps.Size(32, 32)
    );

    if (last_location.lat && last_location.lng) {
      new maps.Marker({
        position: last_location,
        map: map,
        icon: iconMarker,
      });
    }

    const directionsService = new maps.DirectionsService();
    const directionsRenderer = new maps.DirectionsRenderer();
    directionsRenderer.setMap(map);

    console.log("src", src);
    console.log("destination", destination);
    console.log("last_location", last_location);

    var localSrc;
    var localDestination;

    if (last_location.lat && last_location.lng) {
      if (driversign) {
        localSrc = last_location;
        localDestination = destination;
      } else {
        localSrc = last_location;
        localDestination = src;
      }
    } else {
      localSrc = src;
      localDestination = destination;
    }

    directionsService.route(
      {
        origin: localSrc,
        destination: localDestination,
        travelMode: maps.TravelMode.DRIVING,
      },
      (response, status) => {
        console.log("response", response, status);
        if (status === "OK") {
          directionsRenderer.setDirections(response);
        } else {
          console.log("Directions request failed due to " + status);
        }
      }
    );
  };

  const { color, size, qty, true_qty, truck, driver, customer_name, customer_site_name, truck_name, src, item_name } = details;

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div style={{ padding: '16px 20px' }}>
      <h2 style={{ margin: 0, fontWeight: 800, fontSize: 24, color: '#0f172a' }}>Live Tracking Map</h2>
      <div style={{ display: 'grid', gridTemplateColumns: '360px 1fr', gap: 16, marginTop: 12 }}>
        {/* Left - Active Delivery card list (single current job for now) */}
        <Paper style={{ border: '1px solid #e5e7eb', borderRadius: 12, boxShadow: '0 8px 16px rgba(2,6,23,0.06)' }}>
          <div style={{ padding: 16 }}>
            <div style={{ fontWeight: 800, color: '#0f172a', marginBottom: 8 }}>Active Delivery</div>
            <div style={{ border: '1px solid #eef2f7', borderRadius: 12, padding: 12, background: '#ffffff' }}>
              <div style={{ fontWeight: 700, color: '#0f172a' }}>{customer_name}</div>
              <div style={{ fontSize: 12, color: '#64748b', marginTop: 4 }}>{customer_site_name}</div>
              <div style={{ fontSize: 12, color: '#475569', marginTop: 8 }}>Item: <strong>{item_name}</strong></div>
              <div style={{ fontSize: 12, color: '#475569' }}>Load Qty: <strong>{true_qty !== 'N/A' ? parseFloat(true_qty).toFixed(2) : 'N/A'}</strong></div>
              <div style={{ fontSize: 12, color: '#475569' }}>Ordered Qty: <strong>{qty !== 'N/A' ? parseFloat(qty).toFixed(2) : 'N/A'}</strong></div>
              <div style={{ fontSize: 12, color: '#475569' }}>Truck #: <strong>{truck}</strong></div>
              <div style={{ fontSize: 12, color: '#475569' }}>Driver: <strong>{driver}</strong></div>
              <Link to="/dispatched_order">
                <Button size="sm" style={{ marginTop: 10, background: '#0f3b4a', border: 'none', borderRadius: 999 }}>Back to List</Button>
              </Link>
            </div>
          </div>
        </Paper>

        {/* Right - Map panel with gradient header */}
        <Paper style={{ border: '1px solid #e5e7eb', borderRadius: 12, boxShadow: '0 8px 16px rgba(2,6,23,0.06)' }}>
          <div style={{ padding: '12px 16px', borderTopLeftRadius: 12, borderTopRightRadius: 12, background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)', color: '#ffffff', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <div style={{ fontWeight: 700 }}>Route Overview</div>
            <div style={{ fontSize: 12, opacity: 0.9 }}>Tracking active delivery</div>
          </div>
          <div style={{ height: '72vh' }}>
            <GoogleMapReact
              bootstrapURLKeys={{ key: process.env.REACT_APP_MAPS_API_KEY }}
              defaultCenter={center}
              defaultZoom={zoom}
              onGoogleApiLoaded={({ map, maps }) => handleApiLoaded(map, maps)}
              yesIWantToUseGoogleMapApiInternals
            ></GoogleMapReact>
          </div>
        </Paper>
      </div>
    </div>
  );
};

export default ProsMap;
